import { render, staticRenderFns } from "./Group-Browse-Folder.vue?vue&type=template&id=e2e95bc6&scoped=true&"
import script from "./Group-Browse-Folder.vue?vue&type=script&lang=js&"
export * from "./Group-Browse-Folder.vue?vue&type=script&lang=js&"
import style0 from "./Group-Browse-Folder.vue?vue&type=style&index=0&id=e2e95bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e95bc6",
  null
  
)

export default component.exports